// extracted by mini-css-extract-plugin
export default {"triangle":"ProgressBar_triangle__pKhJd","progressBarContainer":"ProgressBar_progressBarContainer__ekXdW"};